import axios from '@/libs/axios'
import { handleCatch } from '@/utils'

export default {
  async importExaminationScores(params) {
    try {
      const response = await axios.post('uni/studentExaminationRooms/importExaminationScores', { params })
      const { data } = response
      return {
        code: data.code,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
      return {
        code: 0,
        message: 'Có lỗi xảy ra khi import điểm thi',
      }
    }
  },
}
